import React, { useState, useEffect } from 'react';
import { launchLDDzoho } from '../drFuncs';
import { lddGlobalSessionInfo, NavObjectType } from '../../../Components/navigationTypes';
import { useAppSelector } from '../../../redux/hooks';
import styles from './AdsCarousel.module.css';
import { adMapper } from '../../../util/rpwConst';

interface Ad {
    imageUrl: string;
    link: string;
    alt: string;
}

const ads: Ad[] = [
    {
        imageUrl: 'InFile_2.png',
        link: 'https://zfrmz.com/cdIabRvui3fve5FCSqvc',
        alt: 'dr ad ClientConnect Infile'
    },
    {
        imageUrl: 'InFile_3.png',
        link: 'https://zfrmz.com/cdIabRvui3fve5FCSqvc',
        alt: 'dr ad MyDrive Infile'
    },
    {
        imageUrl: 'InFile_1.png',
        link: 'https://zfrmz.com/cdIabRvui3fve5FCSqvc',
        alt: 'dr ad RenAI Infile'
    },
    {
        imageUrl: 'InFile_4.png',
        link: 'https://zfrmz.com/cdIabRvui3fve5FCSqvc',
        alt: 'dr ad Realti Infile'
    }
];

export const AdsCarousel: React.FC = () => {
    const [currentAd, setCurrentAd] = useState(ads[0]);
    const sessionInfo: lddGlobalSessionInfo = useAppSelector((state) => state.SessionInfo);
    const page: NavObjectType = useAppSelector((state) => state.currentNavigation.page);
    let drawerClasses = '';
    if (page.component === 'main') {
        drawerClasses = 'open'
    }

    useEffect(() => {
        const randomIndex = Math.floor(Math.random() * ads.length);
        setCurrentAd(ads[randomIndex]);
    }, []);

    return (
        <div className={styles.adsCarousel + ` toolbar-content ${drawerClasses}`}>
            <img 
                src={"./" + currentAd.imageUrl} 
                alt={currentAd.alt} 
                className={styles.adImage}
                onClick={() => launchLDDzoho(currentAd.link, sessionInfo, adMapper[currentAd.imageUrl.split('.')[0]])}
            />
        </div>
    );
};